/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `AUTO` - Auto
 * * `MANUAL` - Manual
 * @export
 */
export const TransitionTypeEnum = {
    Auto: 'AUTO',
    Manual: 'MANUAL'
} as const;
export type TransitionTypeEnum = typeof TransitionTypeEnum[keyof typeof TransitionTypeEnum];


export function instanceOfTransitionTypeEnum(value: any): boolean {
    for (const key in TransitionTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(TransitionTypeEnum, key)) {
            if (TransitionTypeEnum[key as keyof typeof TransitionTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TransitionTypeEnumFromJSON(json: any): TransitionTypeEnum {
    return TransitionTypeEnumFromJSONTyped(json, false);
}

export function TransitionTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionTypeEnum {
    return json as TransitionTypeEnum;
}

export function TransitionTypeEnumToJSON(value?: TransitionTypeEnum | null): any {
    return value as any;
}

export function TransitionTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TransitionTypeEnum {
    return value as TransitionTypeEnum;
}

